import { useCallback, useMemo, useState } from 'react';
import { RadiusIcon } from '@rsos/assets/icons';
import HoveredButton from '@rsos/components/capstone/HoveredButton';
import usePortalType from '@rsos/utils/usePortalType';
import UncertaintyConfidence from '../UncertaintyConfidence';
import { handleCopy } from '../helpers/handleCopy';
import {
  RowBox,
  LeftText,
  MiddleText,
  CopyColumnBox,
  IconWrapper,
} from '../styles/common.styles';

const Uncertainty = ({
  uncertaintyRadius,
  confidence,
  isHoverable,
  irpVersion,
  payloadID,
  requestID,
  secondary,
}) => {
  const { portalType } = usePortalType();

  const [isCopied, setIsCopied] = useState();

  const uncertaintyValue = useMemo(
    () =>
      uncertaintyRadius < 0
        ? `Unknown`
        : `${Number(uncertaintyRadius).toFixed(1)}m`,
    [uncertaintyRadius],
  );

  const confidenceValue = useMemo(
    () => (confidence ? `, Confidence: ${confidence}` : ''),
    [confidence],
  );

  const onClick = useCallback(() => {
    handleCopy({
      value: `Uncertainty Radius: ${uncertaintyValue} ${confidenceValue}`,
      name: 'Uncertainty Radius and Confidence',
      irpVersion,
      payloadID,
      requestID,
      portalType,
      onStart: () => {
        setIsCopied(true);
      },
      onEnd: () => {
        setIsCopied(false);
      },
    });
  }, [
    confidenceValue,
    irpVersion,
    payloadID,
    portalType,
    requestID,
    uncertaintyValue,
  ]);

  if (!uncertaintyRadius) return null;

  return (
    <RowBox br="5px" isHoverable={isHoverable} copied={isCopied}>
      <RowBox>
        <IconWrapper>
          <RadiusIcon width={secondary && 10} height={secondary && 10} />
        </IconWrapper>
        <CopyColumnBox>
          <RowBox data-name="uncertainty">
            <LeftText secondary={secondary}>Uncertainty Radius:&nbsp;</LeftText>
            <MiddleText secondary={secondary} data-name="uncertainty-text">
              {uncertaintyValue}
            </MiddleText>
          </RowBox>
          <UncertaintyConfidence confidence={confidence} />
        </CopyColumnBox>
      </RowBox>
      {isHoverable && (
        <HoveredButton onClick={onClick} withIcon isCopied={isCopied} />
      )}
    </RowBox>
  );
};

export default Uncertainty;
